import { LazyMotion, MotionConfig } from "motion/react";

const loadDomAnimation = () => import("./domAnimation").then((module) => module.default);

export function LandingMotionProvider({ children }) {
  return (
    <MotionConfig reducedMotion="user">
      <LazyMotion features={loadDomAnimation} strict>
        {children}
      </LazyMotion>
    </MotionConfig>
  );
}
